import styled from "styled-components";

export const StyledWrapper = styled.span`
  display: inline-flex;
  border-radius: 100%;
  position: relative;
`;

export const StyledAvatar = styled.img`
  border-radius: 100%;
  object-fit: cover;
`;
